import { makeStyles } from '@material-ui/core/styles';

import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  feeBreakdownTable: {
    '& td, th': {
      borderBottom: 'none',
      padding: theme.spacing(4, 0),
      whiteSpace: 'nowrap',
      display: 'flex',
      justifyContent: 'space-between',
      '&:first-of-type': {
        minWidth: 110
      }
    },
    '& tr': {
      borderBottom: `1px solid ${theme.colorPalette.beige_25_op_30}`,
      '&:first-of-type > td': {
        paddingTop: 0
      },
      '&:last-of-type': {
        borderBottom: 'none',
        '& > td': {
          paddingBottom: 0
        }
      }
    },
    '& tr:last-of-type': {
      borderBottom: 'none'
    }
  },
  feeDescription: {
    color: theme.colorPalette.beige_50,
    width: '100%'
  },
  feeSummary: {
    alignItems: 'center',
    display: 'flex',
    height: 73,
    gap: theme.spacing(4),
    justifyContent: 'flex-end'
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    height: 20
  },
  feeSelectorContainer: {
    marginTop: 32,
    display: 'flex',
    justifyContent: 'space-between'
  },
  card: {
    display: 'flex',
    backgroundColor: theme.colorPalette.green_100,
    margin: theme.spacing(4, 0),
    alignItems: 'center',
    padding: theme.spacing(6)
  },
  // Reskin: with no fees there are no rows to keep dark, so the empty state is a light card.
  emptyCard: reskinStyles(theme, {
    backgroundColor: theme.colorPalette.white,
    '& $title, & $subTitle': { color: theme.colorPalette.green_100 }
  }),
  noFeesCard: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  title: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 'normal',
    color: theme.colorPalette.beige_50
  },
  subTitle: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 'normal',
    color: theme.colorPalette.beige_50
  },
  button: {
    fontWeight: 600,
    fontSize: 16,
    width: 196
  },
  normal: ({ readOnly }) => ({
    alignItems: 'center',
    display: 'grid',
    gridTemplateColumns: readOnly ? '3fr 1fr 1fr' : '3fr 1fr 1fr 1fr',
    justifyContent: 'space-between'
  }),
  undo: {
    opacity: 0.6
  },
  // The card stays dark green in the new look, where text buttons default to dark green text and no
  // outline. Outlined like the new look's other secondary actions so it reads as a button at rest.
  removeButton: reskinStyles(theme, {
    border: `2px solid ${theme.colorPalette.white}`,
    color: theme.colorPalette.white,
    '&:hover': { backgroundColor: theme.colorPalette.green_90 },
    '&.Mui-disabled': { color: `${theme.colorPalette.white} !important` }
  })
}));

export default useStyles;
